import React from "react";
import GilletPrimoKnopfen from "../Garments/GilletPrimoKnopfen";

export default function GiletPrimoKnopfenPage() {
  return <GilletPrimoKnopfen />;
}
